import { render, staticRenderFns } from "./SetMetadataModal.vue?vue&type=template&id=2af37193"
import script from "./SetMetadataModal.vue?vue&type=script&lang=js"
export * from "./SetMetadataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports